export const sortByStartDateAsc = (a, b) =>
  new Date(a.start_date) - new Date(b.start_date)

export const sortByStartDateDesc = (a, b) =>
  new Date(b.start_date) - new Date(a.start_date)

export const sortFunc = (a, b) =>
  a.localeCompare(b, undefined, { sensitivity: 'base' })